module.exports = __webpack_public_path__ + "img/yue.db3d92a9.png";